import { ref } from 'vue'

/**
 * @param {{
 *   resetDone: Boolean
 * }} props
 */
export const setup = props => {
  const self = {
    modalVisible: ref(props.resetDone),

    closeModal: () => {
      self.modalVisible.value = false
      return self
    },
  }

  return {
    // props
    modalVisible: self.modalVisible,

    // functions
    closeModal: self.closeModal,
  }
}
